export function requireProps(errorLabel, requiredProps) {
	_.map(requiredProps, (value, key) => {
		if (!value) {
			throw new Error(`${errorLabel}: required prop '${key}' was not given!`)
		}
	})
}
